<template>
    <b-form-group class="b-form-group-flatpickr-custom">
        <b-input-group>
            <flat-pickr
                ref="REF_CALENDAR_YEAR"
                v-model="yearModel"
                class="form-control create-form-flatpicker border-right-0"
                :config="datePickConfig"
                placeholder="YYYY"
            />
            <b-input-group-prepend
                is-text
                class="cursor-pointer"
                @click="openCalendar"
            >
                <SVGCalendarNumberIcon/>
            </b-input-group-prepend>
        </b-input-group>
    </b-form-group>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import useSelectYear from '@/composables/useSelectYear'
import YearSelect from '@/libs/yearSelect'
import { getCurrentInstance, ref, toRefs, computed, watch } from '@vue/composition-api'
import SVGCalendarNumberIcon from '@/assets/images/icons/calendar-with-number.svg'
export default {
    components: {
        flatPickr,
        SVGCalendarNumberIcon
    },
    props: ['clearable', 'storeKey'],
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const REF_CALENDAR_YEAR = ref(null)
        const { storeKey } = toRefs(props)
        const {
            yearModel,
            yearOptions,
            handleSelectYear
        } = useSelectYear(storeKey.value)
        const handleChange = (selectedArr, inputText, fp) => {
            handleSelectYear(inputText)
        }
        const minDate = computed(() => yearOptions.value[yearOptions.value.length - 1])
        const maxDate = computed(() => yearOptions.value[0])
        const yearSelectInstance = ref(new YearSelect({
            minDate: minDate.value,
            maxDate: maxDate.value
        }))
        const openCalendar = () => {
            vm.$nextTick(() => {
                if (REF_CALENDAR_YEAR.value) {
                    REF_CALENDAR_YEAR.value.fp.open()
                }
            })
        }
        const datePickConfig = computed(() => ({
            mode: 'single',
            plugins: [
                yearSelectInstance.value
            ],
            disable: [
                function (date) {
                    return !yearOptions.value.includes(date.getFullYear().toString())
                }
            ],
            onChange: [handleChange],
            onOpen: function (selectedArr, inputText, fp) {
                if (!fp.config.minDate && minDate.value) fp.config.minDate = new Date(minDate.value, 0)
                if (!fp.config.maxDate && maxDate.value) fp.config.maxDate = new Date(maxDate.value, 0)
                fp.config.navRange = [...fp.config.currentRange]
                fp.currentYearElement.value = fp.config.navRange[0] + '-' + fp.config.navRange[1]
                fp.config.buildYears()
            },
            allowInput: false
        }))

        watch(yearOptions, (value, oldValue) => {
            yearModel.value = value[0]
            yearSelectInstance.value = new YearSelect({
                minDate: minDate.value,
                maxDate: maxDate.value
            })
        }, {
            deep: true
        })
        return {
            REF_CALENDAR_YEAR,
            yearModel,
            yearOptions,
            datePickConfig,
            handleSelectYear,
            openCalendar
        }
    }
}
</script>
